const getCollectCookie = (cookie_name) => {
  const nameEQ = cookie_name + '=';
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    const c = ca[i].trim(); // 自动去除前后空格
    if (c.indexOf(nameEQ) === 0) {
      return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
  }
  return '';
};
//获取浏览器版本号
const getCollectBrowserNameVersion = () => {
  const userAgent = navigator.userAgent;
  let version = "";

  if (/rv:([\d.]+)/.test(userAgent)) {
    version = userAgent.match(/rv:([\d.]+)/)?.[1] ?? "";
  } else if (/msie\s([\d.]+)/.test(userAgent)) {
    version = userAgent.match(/msie\s([\d.]+)/)?.[1] ?? "";
  } else if (/edge\/([\d.]+)/.test(userAgent)) {
    version = userAgent.match(/edge\/([\d.]+)/)?.[1] ?? "";
  } else if (/chrome\/([\d.]+)/.test(userAgent)) {
    version = userAgent.match(/chrome\/([\d.]+)/)?.[1] ?? "";
  } else if (/safari\/([\d.]+)/.test(userAgent)) {
    version = userAgent.match(/safari\/([\d.]+)/)?.[1] ?? "";
  } else if (/firefox\/([\d.]+)/.test(userAgent)) {
    version = userAgent.match(/firefox\/([\d.]+)/)?.[1] ?? "";
  }

  return version;
};

//获取浏览器类型
const getCollectBrowserType = () => {
  const userAgent = navigator.userAgent;
  if (userAgent.indexOf("Opera") > -1 || userAgent.indexOf("OPR") > -1) {
    return "Opera";
  } else if (
    userAgent.indexOf("compatible") > -1 &&
    userAgent.indexOf("MSIE") > -1
  ) {
    return "IE";
  } else if (userAgent.indexOf("Edge") > -1) {
    return "Edge";
  } else if (userAgent.indexOf("Firefox") > -1) {
    return "Firefox";
  } else if (
    userAgent.indexOf("Safari") > -1 &&
    userAgent.indexOf("Chrome") == -1
  ) {
    return "Safari";
  } else if (
    userAgent.indexOf("Chrome") > -1 &&
    userAgent.indexOf("Safari") > -1
  ) {
    return "Chrome";
  } else {
    return "Unkonwn";
  }
};
const getCollectIsMobile = () => {
  const userAgentInfo = navigator.userAgent;
  const Agents = [
    "Android",
    "iPhone",
    "SymbianOS",
    "Windows Phone",
    "iPad",
    "iPod",
  ];
  const getArr = Agents.filter((i) => userAgentInfo.includes(i));
  return getArr.length ? true : false;
};
function eventCollect(event) {
  const url =
    window.location.href.includes("https://help.dsers.com/")
      ? "https://api-gw.dsers.com"
      : "https://api-gw-test.dsers.com";
  // const url = "https://api-gw.dsers.com";
  const baseUrl = `https://api-gw.dsers.com/dsers-collect-bff/web_normalize`;
  function getParams() {
    return JSON.stringify({
      version: 6,
      event_category: "web",
      event_type: "normalize",
      event_label: "collect",
      trace_id: "",
      log_create_time: 0,
      custom_data: {
        event: {
          ...event,
          timestamp: Math.ceil(Date.now() / 1000),
        },
        user: {
          _clck: getCollectCookie("_clck") || "",
          _da: getCollectCookie("_da") || "",
          _ga: getCollectCookie("_ga") || "",
          first_visit_time:
            parseInt(getCollectCookie("first_visit_time") || "") || 0,
          is_initial_access: window.newUser ? 1 : 0,
          id: getCollectCookie("userInfoId") || "",
          email: getCollectCookie("userInfoEmail") || "",
          first_visit_referrer: getCollectCookie('first_visit_referrer') || '',
          first_visit_location: getCollectCookie('first_visit_location') || '',
          redirect_referrer: getCollectCookie('redirect_referrer') || '',
          redirect_referrer_ts: getCollectCookie('redirect_referrer_ts') || '',
          redirect_location: getCollectCookie('redirect_location') || '',
        },
        app_info: {
          id: "",
          name: "dsers-web-site",
          version: "1.0.5",
        },
        // env: process.env.NODE_ENV,
        web_info: {
          hostname: window.location.hostname,
          page_referrer: document.referrer || "",
          page_location: window.location.href,
        },
        device: {
          category: getCollectIsMobile() ? "mobile" : "pc",
          user_agent: navigator.userAgent,
          language: navigator.language.toLowerCase(),
          web_info: {
            browser: getCollectBrowserType(),
            browser_version: getCollectBrowserNameVersion(),
          },
        },
      },
    });
  }
  if (typeof navigator.sendBeacon === "function") {
    navigator.sendBeacon(baseUrl, getParams());
  } else {
    fetch(baseUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: getParams(),
    });
  }
}
